import script from "./assign-marketing-work.vue?vue&type=script&setup=true&lang=js"
export * from "./assign-marketing-work.vue?vue&type=script&setup=true&lang=js"

import "./assign-marketing-work.vue?vue&type=style&index=0&id=1171872f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1171872f"]])

export default __exports__